// This icon file is generated automatically.
var PStarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.19 4.52l-3.97-.58L7.45.34a.5.5 0 00-.9 0l-1.77 3.6-3.97.58a.5.5 0 00-.28.85l2.87 2.8-.67 3.95a.5.5 0 00.72.53L7 10.78l3.55 1.87c.1.05.2.07.32.05a.5.5 0 00.4-.58l-.67-3.95 2.87-2.8a.5.5 0 00-.28-.85zm-3.8 3.26l.56 3.28L7 9.51l-2.95 1.55.56-3.28-2.39-2.33 3.3-.48L7 1.98l1.47 2.99 3.3.48L9.4 7.78z", "fill-rule": "nonzero" } }] }, "name": "p-star", "theme": "outlined" };
export default PStarOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PStarOutlined.js
// module id = 3650
// module chunks = 0